import { Component, computed, effect, EventEmitter, Input, input, Output, viewChild } from '@angular/core';
import { Breakpoint, BundleType, CardStyleType, NodeModel } from '../../../common/models';
import { SwiperComponent } from '../../../common/components';


@Component({
    selector: 'lib-content-highlight-widget',
    templateUrl: './content-highlight-widget.component.html',
    styleUrls: ['./content-highlight-widget.component.scss'],
    standalone: false
})
export class ContentHighlightWidgetComponent {
  public swiperComponent = viewChild(SwiperComponent);

  @Input() public title: string;
  @Input() public items: NodeModel[] = [];
  @Input() public textColor: string;
  @Input() public langcode: string;
  @Input() public sliderEnabled = false;
  @Input() public mobileCardStyle: string;
  @Input() public isPaymentEnabled = false;
  @Input() public courseDetailsEnabled = false;
  public previewContainerBreakpoint = input<Breakpoint>();

  @Output() public openDetails: EventEmitter<NodeModel> = new EventEmitter();
  @Output() public navigateToEntity: EventEmitter<{ event: Event, item: NodeModel }> = new EventEmitter();

  public readonly bundleTypes: typeof BundleType = BundleType;
  public readonly mobileCardStyleTypes: typeof CardStyleType = CardStyleType;

  public swiperOptions = computed(() => {
    const breakpoint = this.previewContainerBreakpoint() ?? Breakpoint.DESKTOP;

    const configsOverrides = {
      [Breakpoint.DESKTOP]: undefined,
      [Breakpoint.MOBILE]: {
        slidesPerView: 1,
        showOverflow: true,
        reducedWidth: true
      },
      [Breakpoint.TABLET]: {
        slidesPerView: 3,
        showOverflow: false,
        reducedWidth: false
      }
    };

    const desktop = {
      0: { slidesPerView: 1, showOverflow: true, reducedWidth: true },
      480: { slidesPerView: 2, showOverflow: false, reducedWidth: false },
      640: { slidesPerView: 3, showOverflow: false, reducedWidth: false },
      1024: { slidesPerView: 4, showOverflow: false, reducedWidth: false }
    };

    const override = configsOverrides[breakpoint];

    return {
      breakpoints: Object.fromEntries(
        Object.entries(desktop).map(([width, config]) => [
          width,
          override ?? config
        ])
      )
    };
  });

  constructor() {
    effect(() => {
      const breakpoint = this.previewContainerBreakpoint();
      const swiperComponent = this.swiperComponent();

      if (!swiperComponent?.swiper || !breakpoint) {
        return;
      }

      const bp: 0 | 480 | 640 | 1024 = swiperComponent.swiper.currentBreakpoint ?? 0;
      const options = this.swiperOptions();
      const bpParams = options.breakpoints[bp] ?? options.breakpoints[0];

      Object.assign(swiperComponent.swiperContainerRef.nativeElement, bpParams);
      Object.assign(swiperComponent.swiper.params, bpParams);
      swiperComponent.swiper.update();
    });
  }

  public navigate(event: Event, item: NodeModel): void {
    this.navigateToEntity.emit({ event, item });
  }
}
